<template>
	<span class="tag" :class="classColor">{{ output }}</span>
</template>

<script>
export default {

	props: [ 'row', 'field' ],

	computed: {
		classColor: function() {
			if (this.row[ this.field.slug ]) {
				return 'good-bg';
			}

			return 'bad-bg';
		},

		output: function() {
			if (this.row[ this.field.slug ]) {
				return 'Active';
			}

			return 'Inactive';
		}
	}
};
</script>
